export const RESET_SELECT_OPTIONS = 'RESET_SELECT_OPTIONS';
export const RESET_SELECT_VERSIONS = 'RESET_SELECT_VERSIONS';
export const API_REQUEST_SUCCESS = 'API_REQUEST_SUCCESS';
export const API_REQUEST_FAILURE = 'API_REQUEST_FAILURE';
export const FORM_IS_DIRTY = 'FORM_IS_DIRTY';
export const SELECTED_VERSION = 'SELECTED_VERSION';

/**
 * Reset form select option state
 * @returns {object} - return action object
 */
export const resetSelectsOptions = () => ({
  type: RESET_SELECT_OPTIONS,
});

/**
 * Reset form versions option state
 * @returns {object} - return action object
 */
export const resetVersions = () => ({
  type: RESET_SELECT_VERSIONS,
});

/**
 * Initial request
 * @returns {object} - return action object
 */
export const apiRequestSuccess = (payload) => ({
  type: API_REQUEST_SUCCESS,
  payload,
});

/**
 * Initial request
 * @returns {object} - return action object
 */
export const apiRequestFailure = () => ({
  type: API_REQUEST_FAILURE,
});

/**
 * Initial request
 * @returns {object} - return action object
 */
export const formIsDirty = (payload) => ({
  type: FORM_IS_DIRTY,
  payload,
});

/**
 * Initial request
 * @returns {object} - return action object
 */
export const selectedVersion = (payload) => ({
  type: SELECTED_VERSION,
  payload,
});
